<template>
  <div class="dialog-modal" >
    <div class="dialog-container" @click.stop>
      <div class="dialog-header" v-if="title">
        {{title}}
        <i class="el-icon-close" @click="closeDialog"></i>
      </div>
      <div class="dialog-content" :style="{width, height}">
        <i v-if="!title" class="el-icon-close contentClose" @click="closeDialog"></i>
        <slot name="content"></slot>
      </div>
      <div class="dialog-footer" v-if="!noFooter">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    visible: {
      default: false
    },
    title: {
      type: String
    },
    width: {
      type: String,
      default: "640px"
    },
    height: {
      type: String,
      default: "auto"
    },
    noFooter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    closeDialog() {
      this.$emit("update:visible", false);
    }
  }
};
</script>
<style lang="less">
.dialog-content {
  .el-select {
    width: 100%;
  }
  .el-date-editor.el-input {
    width: 100%;
    .el-input__inner {
      border-radius: 5px;
      padding-left: 15px;
    }
  }
  .el-form-item--small .el-form-item__label {
    line-height: 20px;
    // padding-bottom: 5px;
  }
}
</style>

<style lang="less" scoped>
@import url("../../assets/css/mixin.less");
.dialog-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
  display: flex;
  justify-content: center;
  align-items: center;
  @keyframes fadeIn {
    0% {
      background: transparent;
    }
    100% {
      background: rgba(0, 0, 0, 0.5);
    }
  }
  animation: fadeIn 0.5s linear forwards;
  .dialog-container {
    position: relative;
    background: #fff;
    border-radius: 5px;
    mask: radial-gradient(
      #000 calc(1% * var(--seed)),
      transparent calc(1% * var(--seed))
    );
    mask-size: 60px 60px;
    animation: seed 0.5s;
    .dialog-header {
      height: 60px;
      padding: 0 20px;
      border-bottom: 1px solid @borderColor;
      display: flex;
      justify-content: center;
      // text-align:center;
      align-items: center;
      .sc(16px, #595959);
      font-weight: bold;
      i {
        position: absolute;
        top: 22px;
        right: 20px;
        .sc(14px, #595959);
        cursor: pointer;
        &:hover {
          color: @hoverColor;
        }
      }
    }
    .dialog-content {
      padding: 36px 35px;
      overflow: auto;
      max-height: 85vh;
      display: flex;
      flex-direction: column;
      .content_tishi {
        text-align: center;
        .tital {
          display: flex;
          align-items: center;
          justify-content: center;
            .contentdelete {
              font-size: 20px;
              font-weight: 600;
              }
          i {
            font-size: 30px;
            margin-right: 10px;
          }
        }
      }
      .disabledescr{
        // margin-left: 40px;
        display: flex;
        justify-content: center;
        margin-top: 10px;
        font-size: 10px;
      }
      .deletfotter {
        margin-top: 50px;
        .button-hollow {
          width: 100px;
          height: 32px;
          margin: 0 6px;
        }
        .button-solid {
          margin: 0 6px;
          width: 100px;
          height: 32px;
        }
      }
      .contentClose {
        position: absolute;
        top: 20px;
        right: 20px;
        .sc(14px, #595959);
        cursor: pointer;
        &:hover {
          color: @hoverColor;
        }
      }
    }
    .dialog-footer {
      background: #fafafa;
      height: 60px;
      padding: 0 20px;
      border-top: 1px solid @borderColor;
      display: flex;
      // justify-content: flex-end;
      justify-content: center;
      align-items: center;
      .button {
        font-size: 14px;
        padding: 6px 25px;
        border-radius: 5px;
        min-width: 100px;
        cursor: pointer;
        margin: 0 6px;
        // margin-left: 20px;
      }
      .button-hollow {
        border-radius: 5px;
        .sc(14px, #666);
        border-color: #ddd;
        .button;
        &:hover {
          background: #f8f9fa;
        }
      }
      .button-solid {
        .button;
      }
    }
  }
}
</style>

